import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FSFNotAvailableLightBoxActions } from '../constants/fsf_not_available_light_box/fsf_not_available_light_box_actions';

class FSFNotAvailableLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return { visible: false };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.FSF_NOT_AVAILABLE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case FSFNotAvailableLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case FSFNotAvailableLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const FSFNotAvailableLightBoxStore = new FSFNotAvailableLightBoxStoreClass(Dispatcher);
export { FSFNotAvailableLightBoxStore };